export const successionPoolSelector = state => state.successionPool;
